import { Group, Text } from "@mantine/core";
import { ImageProxy } from "./image-proxy";

type Props = {
  name?: string;
  logo: string;
  size?: "sm" | "lg";
  pos?: "left" | "right";
  maw?: number;
};

export function TeamBadge({
  name,
  logo,
  size = "sm",
  pos = "left",
  ...props
}: Props) {
  const imgSize = size === "lg" ? 34 : 24;
  const textSize = size === "lg" ? "lg" : "md";
  const imgProxy = <ImageProxy src={logo} height={imgSize} loading="lazy" />;

  return (
    <Group gap={8} wrap="nowrap" maw={props.maw}>
      {pos === "left" && imgProxy}
      {name && (
        <Text fw={500} title={name} size={textSize} truncate>
          {name}
        </Text>
      )}
      {pos === "right" && imgProxy}
    </Group>
  );
}
